module.exports = {
    message: {
        language: "en",
        title: 'Account cancellation reminder',
        contentData: [],
        account: 'account',
        accountMsg: '请填写账号',
        password: 'password',
        passwordMsg: '请填写密码',
    }
}